import { QueryCache, QueryClient } from '@tanstack/react-query';
import { authEvents } from './auth-events';

const AUTH_POSTGREST_CODES = new Set(['PGRST301', 'PGRST302']);
const AUTH_MESSAGE_RE = /jwt|unauthorized|invalid token/i;

export function isAuthError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as { status?: number; code?: string; message?: string };
  if (e.status === 401) return true;
  if (e.code && AUTH_POSTGREST_CODES.has(e.code)) return true;
  if (typeof e.message === 'string' && AUTH_MESSAGE_RE.test(e.message)) return true;
  return false;
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (isAuthError(error)) {
        authEvents.emitInvalidSession('session_invalid');
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes garbage collection
      retry: (failureCount, error) => {
        if (isAuthError(error)) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
